import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GridApi, ColumnApi, ColDef, GridReadyEvent } from 'ag-grid-community';
import * as moment from 'moment';
import { AlertService } from 'src/app/_services/alert.service';
import { AmountInputCellRenderer } from 'src/app/common/amount-input-cell-renderer.component';
import { DatepickerCellRenderer } from 'src/app/common/datepicker-cell-renderer.component';
import { InputCellRenderer } from 'src/app/common/input-cell-renderer.component';
import { SelectCellRenderer } from 'src/app/common/select-cell-renderer.component';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { ProductService } from '../../product-management/product-service';
import { ProductSubCategoryService } from '../../product-subcategory-management/product-subcategory-service';
import { ServiceProviderService } from '../../service-provider-management/service-provider-service';
import { CommissionProfileService } from '../commission-profile-service';
import { param } from 'jquery';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';


export interface CustomerListFilter {
  "columns"?: any;
  "fullname"?: string,
  "mobile"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "emailId"?: string,
  "Status"?: string,
  "KycStatus"?: string

}

export class SlabTableFormat {
  "id": number;
  "fromAmount": number;
  "toAmount": number;
  "commissionType": String;
  "agentCommission": number;
  "subAgentCommission": number;
  "minCommission": number;
  "maxCommission": number;
  "effectiveUpdatedDate": String;
  "productId" : number;
  "updatedBy": String;
  "updatedOn": String;
  "approvedBy": String;
  "aprrovedOn": String;
  "isAmountDisabled": Boolean;
  "showEditButton": Boolean;
  "isDatepickerDisabled": Boolean;
  "isSelectDisabled": Boolean;
}

const { API_URL, defaultPageSizeArr, defaultPageSize } = environment;

@Component({
  selector: 'app-commission-profile-add',
  templateUrl: './commission-profile-add.component.html',
  styleUrls: ['./commission-profile-add.component.scss']
})
export class CommissionProfileAddComponent implements OnInit {

  
  public permissions : any;
  addCommissionProfileForm: FormGroup;
  submitted: boolean = false;
  submittedCommission: boolean = false;
  activeTab: any = "service";
  globalSearch: string = '';
  public rowData!: any[];
  private filterObj: any = {};
  private gridApi!: GridApi;
  collectiondata: number = 0;
  collectionSize: number = 0;
  private gridColumnApi!: ColumnApi;
  currentPage: number = 1;
  public pageNumber: number
  ellipses: boolean = true;
  maxSize: number;

  private columnApi: ColumnApi;
  private gridApiDirect: GridApi;
  private gridApiSlab: GridApi;
  slabTypeData: SlabTableFormat;
  public directData: any[];
  public slabData: any[];
  public finalCommissionData : any[];
  showDataTable : boolean = false;
  countryDropDown : any[];
  categoryDropDown : any[];
  subCategoryDropDown : any[];
  productDropDown : any[];
  selectedProduct : any;
  serviceProviderDropDown : any[];
  productName : any;
  countryName : any;
  serviceProviderName : any;


  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 170,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefs: ColDef[] = [
    
    {field: 'fromAmount', headerName: 'From Amount', editable:false},
    {
      field: 'toAmount', headerName: 'To Amount', resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
        const toAmountValue = parseFloat(params.newValue);
        const maxBalanceValue = parseFloat(this.addCommissionProfileForm.value.maxBalance);
        if (!isNaN(toAmountValue) && toAmountValue < maxBalanceValue) {
          const nextRowVal = this.gridApiSlab.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex + 1).toString());
          if (rowNode) {
            const nextFromAmount = parseFloat((toAmountValue + 0.01).toFixed(2));
            this.finalCommissionData[params.node.rowIndex + 1].fromAmount = nextFromAmount;
            const newData = { ...rowNode.data, fromAmount: nextFromAmount };
            rowNode.setData(newData);
            this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
          }
        }
      }
    },
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'effectiveUpdatedDate', headerName: 'Effective Update Date', cellRenderer: DatepickerCellRenderer, onCellValueChanged: (params: any) => {
        this.finalCommissionData.map((_: any, i: number) => {
          _.effectiveUpdatedDate = moment(params.newValue, ['YYYY-MM-DD HH:mm']).format("MM-DD-YYYY HH:mm");
        })
        console.log("MAP"); 
        console.log(this.finalCommissionData);
        this.gridApiSlab.setRowData(this.finalCommissionData);
      }
    },
    {
      field: 'commissionType', lockVisible: true, headerName: 'Commission Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
        if (rowNode) {
          this.finalCommissionData[params.node.rowIndex].commissionType = params.newValue;
          this.finalCommissionData[params.node.rowIndex].agentCommission = 0;
          this.finalCommissionData[params.node.rowIndex].subAgentCommission = 0;
          this.gridApiSlab.setRowData(this.finalCommissionData);
        }
      }
    },
    { field: 'agentCommission', headerName: 'Agent Commission', cellRenderer: InputCellRenderer , onCellValueChanged: (params: any) => {
      if (params.data.commissionType == "PERCENTAGE") {
        if(Number(params.newValue) > 100){
          this.alertService.toastWarringMessageAlertWithMessage("Agent Commission cannot be greater than 100 Percentage");
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
          if(rowNode){
            this.finalCommissionData[params.node.rowIndex].agentCommission = 0;
            this.gridApiSlab.setRowData(this.finalCommissionData);
          }
        }
      }else if(params.data.commissionType == "FLAT"){
        console.log(params.data.toAmount);
        if(Number(params.newValue) > Number(params.data.toAmount)){
          this.alertService.toastWarringMessageAlertWithMessage("Agent Commission cannot be greater than 'TO AMOUNT'");
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
          if(rowNode){
            this.finalCommissionData[params.node.rowIndex].agentCommission = 0;
            this.gridApiSlab.setRowData(this.finalCommissionData);
          }
        }
      } 
    }},
    { field: 'subAgentCommission', headerName: 'SubAgent Commission', cellRenderer: InputCellRenderer , onCellValueChanged: (params: any) => {
      if (params.data.commissionType == "PERCENTAGE") {
        if(Number(params.newValue) > 100){
          this.alertService.toastWarringMessageAlertWithMessage("SubAgent Commission cannot be greater than 100 Percentage");
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
          if(rowNode){
            this.finalCommissionData[params.node.rowIndex].subAgentCommission = 0;
            this.gridApiSlab.setRowData(this.finalCommissionData);
          }
        }
      }else if(params.data.commissionType == "FLAT"){
        console.log(params.data.toAmount);
        if(Number(params.newValue) > Number(params.data.toAmount)){
          this.alertService.toastWarringMessageAlertWithMessage("SubAgent Commission cannot be greater than 'TO AMOUNT'");
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
          if(rowNode){
            this.finalCommissionData[params.node.rowIndex].subAgentCommission = 0;
            this.gridApiSlab.setRowData(this.finalCommissionData);
          }
        }
      } 
    }},

  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  constructor(private router: Router,private formBuilder : FormBuilder,private alertService : AlertService, private productService : ProductService, private subCategoryService : ProductSubCategoryService,private sanitizer: DomSanitizer,private providerService : ServiceProviderService,private commissionService : CommissionProfileService,private location : Location,private menuService : MenusService) { }

  async ngOnInit() {

    const path = "/commissionProfile";
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);
    if (this.permissions == null || this.permissions == '' || !this.permissions|| !this.permissions.includes('Add')) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.activeTab ="service";
    this.slabData = [];
    
    this.addCommissionProfileForm = this.formBuilder.group({
      commissionProfileName : ['',Validators.required],
      commissionProfileDesc : ['',Validators.required],
      country : [null,Validators.required],
      category : [null,Validators.required],
      subCategory : [null,Validators.required],
      product : [null,Validators.required],
      serviceProvider : [null,Validators.required],
      maxBalance : ['',Validators.required],
      
    })

    this.productService.getCountryDropdown().subscribe((response:any)=>{
      console.log(response);
      this.countryDropDown = response.response.data;
    })

    this.subCategoryService.getCategoryDropdown().subscribe((response: any) => {
      this.categoryDropDown = response.response.data;
      this.subCategoryDropDown = [];
      this.productDropDown = [];
    })
    
  }




  get addServiceProviderFormControl() {
    return this.addCommissionProfileForm.controls;
  }

  cancelButton(){
    this.router.navigateByUrl('/commissionProfile')
  }
  countryChange(country:any){
    console.log(country);
    this.addCommissionProfileForm.controls.category.setValue(null);
    this.addCommissionProfileForm.controls.subCategory.setValue(null)
    this.addCommissionProfileForm.controls.product.setValue(null)
    this.addCommissionProfileForm.controls.serviceProvider.setValue(null)
    this.addCommissionProfileForm.controls.maxBalance.setValue("");
    if(country){
      this.countryName = country.name;
    }
    this.subCategoryDropDown = [];
    this.productDropDown = [];
    this.serviceProviderDropDown = [];
  }

  categoryChange(category: any) {
    console.log(category);
    this.subCategoryDropDown = [];
    this.productDropDown = [];
    this.serviceProviderDropDown = [];
    if(category){
      this.productService.getSubCategoryDropdownById(category.id).subscribe((response: any) => {
        this.subCategoryDropDown = response.response.data;
      });
    }
    this.addCommissionProfileForm.controls.subCategory.setValue(null)
    this.addCommissionProfileForm.controls.product.setValue(null)
    this.addCommissionProfileForm.controls.serviceProvider.setValue(null)
    this.addCommissionProfileForm.controls.maxBalance.setValue("");

  }

  subCategoryChange(subCategory : any){
    console.log(subCategory);
    this.productDropDown = [];
    this.serviceProviderDropDown = [];
    if(subCategory){
      this.commissionService.productDropdown(this.addCommissionProfileForm.value.country,subCategory.id).subscribe((response: any) => {
        console.log(response);
        this.productDropDown = response.response.data;
      });
    }
    this.addCommissionProfileForm.controls.product.setValue(null)
    this.addCommissionProfileForm.controls.serviceProvider.setValue(null)
    this.addCommissionProfileForm.controls.maxBalance.setValue("");
  }

  productChange(product : any){
    console.log(product);
    this.serviceProviderDropDown = [];
    if(product){
      this.productName = product.name;
      this.commissionService.serviceProviderDropdown(this.addCommissionProfileForm.value.country,product.id).subscribe((response: any) => {
        console.log(response);
        this.serviceProviderDropDown = response.content;
      });
    }
    this.addCommissionProfileForm.controls.serviceProvider.setValue(null)
    this.addCommissionProfileForm.controls.maxBalance.setValue("");
  }

  serviceProviderChange(serviceProvider : any){
    console.log(serviceProvider);
    this.serviceProviderName = "";
    this.addCommissionProfileForm.controls.maxBalance.setValue("");
    if(serviceProvider){
      this.serviceProviderName = serviceProvider.name;
      this.addCommissionProfileForm.controls.maxBalance.setValue(serviceProvider.maxBalance);
    }
  }


  saveCommissionProfile(data:any){
    this.submitted = true;
    console.log(data);
    if(this.addCommissionProfileForm.valid){
      console.log("Valid");
      this.activeTab = "commission";
    }else{
      console.log("Not Valid");
    }
  }

  saveCommissionSlab(){
    if(this.addCommissionProfileForm.valid){
      console.log("Valid");
        this.finalCommissionData = JSON.parse(JSON.stringify(this.finalCommissionData));
        this.finalCommissionData.map((_:any)=>{
        delete _.isAmountDisabled;
      })

      let requestForm = {
        "name": this.addCommissionProfileForm.value.commissionProfileName,
        "description": this.addCommissionProfileForm.value.commissionProfileDesc,
        "productId": this.addCommissionProfileForm.value.product,
        "countryId" : this.addCommissionProfileForm.value.country,
        "serviceProviderId" : this.addCommissionProfileForm.value.serviceProvider,
        "slabs" : this.finalCommissionData,
      };
      console.log("Request Data : ",requestForm)
    this.commissionService.saveCommissionProfile(requestForm).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        Swal.fire('Commission Profile save successfully', '', 'success').then((result)=>{
          if (result.isConfirmed) {
            this.router.navigate(['/commissionProfile']);
          } 
        });
      }else if(response.response.status == 400){
        Swal.fire(response.response.message, '', 'error');
        return;
      }else{
        Swal.fire('Error while saving commission profile slab', '', 'error');
      }
    })
    }else{
      console.log("Not Valid");
    }
  }


  switchTab(tab: string): void {
    this.activeTab = tab;
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApiSlab = params.api
  }



  addNewSet(){
    this.selectedProduct = "";
    this.slabData = [];
    this.finalCommissionData = [];
    this.selectedProduct = "";
    console.log(this.selectedProduct);
    this.showDataTable = false;
    if(this.addCommissionProfileForm.valid){
      this.showDataTable = true;
      this.slabTypeData = new SlabTableFormat;
      this.slabTypeData.fromAmount = 1;
      this.slabTypeData.isAmountDisabled = true;
      this.slabTypeData.toAmount = Number(this.addCommissionProfileForm.value.maxBalance);
      this.slabTypeData.productId = this.selectedProduct.id;
      this.slabTypeData.commissionType = "PERCENTAGE";
      this.slabTypeData.agentCommission = 0;
      this.slabTypeData.subAgentCommission = 0;
      this.slabTypeData.effectiveUpdatedDate = moment().format("MM-DD-YYYY HH:mm");;
      this.finalCommissionData.push(this.slabTypeData);
    }
    
  }

  addRow(){
    const newRow = { fromAmount: 1, toAmount: 0, commissionType: "PERCENTAGE", agentCommission: 0,subAgentCommission: 0, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"), isAmountDisabled: false };
    this.finalCommissionData = [newRow, ...this.finalCommissionData];
    this.gridApiSlab.setRowData(this.finalCommissionData);
  }

  clearButton(){
    this.slabData = [];
    this.finalCommissionData = [];
    let slabDataObj = { fromAmount: 1, isAmountDisabled: true, toAmount: Number(this.addCommissionProfileForm.value.maxBalance), commission: 0, commissionType: "PERCENTAGE", effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm")};
    this.finalCommissionData.push(slabDataObj);
    this.gridApiSlab.setRowData(this.finalCommissionData);
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    console.log(charCode);
    if(charCode == 32){
      return true;
    }else if ((charCode == 96 || charCode < 65 ||charCode > 122 ) && (charCode < 48 ||charCode > 57)) {
      return false;
    }
    return true;
  }

  onPaste(e: any) {
    e.preventDefault()
  }

}
